export default "__VITE_ASSET__8e4fd795__"